import { useEffect, useState } from "react";

/** Wide enough (the expanded sidebar) for Lendy's profile to sit beside the chat. */
const WIDE_QUERY = "(min-width: 900px)";

export default function useWideSidebar() {
  const [isWide, setIsWide] = useState(() => window.matchMedia?.(WIDE_QUERY).matches ?? false);
  useEffect(() => {
    const query = window.matchMedia?.(WIDE_QUERY);
    if (!query) return undefined;
    const update = () => setIsWide(query.matches);
    query.addEventListener?.("change", update);
    return () => query.removeEventListener?.("change", update);
  }, []);
  return isWide;
}
